<template>
    <div class="notice bg_fff">
        <v-title title="院内公告">
            <span class="color_main flex1 fs14 tar pr30 pointer">更多</span>
        </v-title>
        <div class="pl15 pr15 pt15 pb15 fs14">
            这里是院内公告
        </div>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";

  export default {
    name: 'home-notice',
    data() {
      return {};
    },
    computed: {},
    components: {VTitle},
    mixins: [],
    created() {

    },
    mounted() {
      setTimeout(this.getData, 2000);
    },
    beforeDestroy() {

    },
    methods: {}
  }
</script>

<style scoped>
    .main {
        height: 200px;
    }

    .main >>> .echarts {
        width: 100%;
        height: 100%;
    }
</style>
